import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig, { getAuthenticatedEntryPath } from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { apiSignIn, apiSignUp } from 'services/AuthService'

function useAuth() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
            const resp = await apiSignIn(values)
            const { token, user } = resp.data

            dispatch(onSignInSuccess(token))
            dispatch(setUser(user))

            const role = user.authority?.[0]
            const redirectUrl = query.get(REDIRECT_URL_KEY)
            navigate(redirectUrl ? redirectUrl : getAuthenticatedEntryPath(role))

            return { status: 'success', message: '' }
        } catch (error) {
            return {
                status: 'failed',
                message: error?.response?.data?.message || error?.toString() || 'Something went wrong',
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            const { token, user } = resp.data

            dispatch(onSignInSuccess(token))
            dispatch(setUser(user))

            const role = user.authority?.[0]
            const redirectUrl = query.get(REDIRECT_URL_KEY)
            navigate(redirectUrl ? redirectUrl : getAuthenticatedEntryPath(role))

            return { status: 'success', message: '' }
        } catch (error) {
            return {
                status: 'failed',
                message: error?.response?.data?.message || error?.toString() || 'Something went wrong',
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => { handleSignOut() }

    return {
        authenticated: token && signedIn,
        signIn,
        signUp,
        signOut,
    }
}

export default useAuth